export const getIconButtonStyle = (theme, disabled, hasImageBeenSet) => ({
  borderRadius: '50px',
  // border: `1px solid ${theme.colors.greys.darkest}`,
  padding: hasImageBeenSet ? '0' : '8px',
  border: disabled
    ? `1px solid ${theme.colors.greys.light}`
    : `1px solid ${theme.colors.greys.darkest}`,
  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: theme.colors.brand.primary,
    '& .picture': {
      filter:
        'invert(71%) sepia(94%) saturate(382%) hue-rotate(120deg) brightness(94%) contrast(94%)',
    },
  },
});

export const getPictureStyle = (hasImageBeenSet) => {
  if (hasImageBeenSet) {
    return {
      width: '34px',
      height: '34px',
      border: 'none',
      padding: '0',
      overflow: 'hidden',
    };
  }

  return {
    width: '16px',
    height: '16px',
  };
};

export const getMenuStyle = (theme) => ({
  padding: '0px',
  '& .MuiPaper-root': {
    borderRadius: '8px',
    boxShadow: `0px 4px 8px ${theme.colors.greys.light}`,
  },
});
